// extracted by mini-css-extract-plugin
export var addressFields = "_k3-0";
export var animationContainer = "_k3-1";
export var footer = "_k3-2";
export var lineItems = "_k3-3";
export var modalContent = "_k3-4";
export var orderName = "_k3-5";
export var strong = "_k3-6";
export var warning = "_k3-7";